import React, { Component } from 'react';
import { connect } from 'react-redux';
//import Helmet from 'react-helmet';

import classNames from 'classnames';
import isTouchDevice from 'is-touch-device';

function mapStateToProps(state) {
  return {
    entry: state.Page.entry,
    template: state.UI.template,
    article: state.Page.article,
    loading: state.Page.loading,
    loaded: state.Page.loaded,
    menuOpen: state.UI.menuOpen,
    showcase: state.Page.showcase,
    projectScrolled: state.UI.projectScrolled,
    ready: state.UI.ready,
    preloading: state.UI.preloading,
  };
}

class Site extends Component {
  render() {
    let { template } = this.props;

    //if(this.props.showcase) entry = this.props.showcase

    let className = classNames(
      'Site',
      { [`Site--${template}`]: template },
      /*'Site--'+entry.template,
					{'Site--project' : this.props.article},*/
      { 'Site--scrolled': this.props.projectScrolled },
      { 'Site--menu': this.props.menuOpen },
      { 'Site--ready': this.props.ready },
      { 'Site--loading': this.props.preloading },
      { 'Site--touch': isTouchDevice() }
    );

    // let title = article ? ' – ' + article.title : '';

    // let head = (
    //   <Helmet key="0">
    //     <title>Village Green {title}</title>
    //   </Helmet>
    // );

    let site = (
      <div className={className} key="1">
        {this.props.children}
      </div>
    );

    return [site];
  }
}

export default connect(mapStateToProps)(Site);



// WEBPACK FOOTER //
// ./src/js/components/Site.jsx